jQuery(document).ready(function ($) {
	var $menu = $(".menu-responsive-wrap-mobile");
	var $back = $(".back-menu");

	// Stack to track parent IDs
	var menuStack = [];

	// Open mobile menu
	$(".open-mobile-menu").click(function () {
		$("body").addClass("menu-is-open");
		$menu.addClass("is-active");

		// Show all level 1 items
		$(".menu-item[data-level='1']").addClass("active");
		$back.removeClass("active");

		// Reset stack
		menuStack = [];
	});

	//close-mobile-menu
	$(".close-mobile-menu").click(function () {
		$("body").removeClass("menu-is-open");
		$menu.removeClass("is-active");

		// Show all level 1 items
		$(".menu-item[data-level='1']").removeClass("active");
		$back.removeClass("active");

		// Reset stack
		menuStack = [];
	});

	// Open submenu
	$(".mobile-nav").on("click", ".open-menu", function (e) {
		e.preventDefault();

		var $parentItem = $(this).closest(".menu-item");
		var parentId = $parentItem.data("id");

		// Push current parent ID to stack
		menuStack.push(parentId);

		// Hide all items
		$(".menu-item").removeClass("active");

		// Show only the direct children of clicked item
		$(".menu-item")
			.filter(function () {
				return $(this).data("parent") === parentId;
			})
			.addClass("active");

		// Show back button
		$back.addClass("active");
	});

	// Back button
	$back.click(function () {
		if (menuStack.length === 0) {
			// Already at top level
			return;
		}

		// Pop last parent ID
		menuStack.pop();

		// Hide all items
		$(".menu-item").removeClass("active");

		if (menuStack.length === 0) {
			// Back to top level → show all level 1 items
			$(".menu-item[data-level='1']").addClass("active");
			$back.removeClass("active");
		} else {
			// Show children of new last parent
			var lastParentId = menuStack[menuStack.length - 1];
			$(".menu-item")
				.filter(function () {
					return $(this).data("parent") === lastParentId;
				})
				.addClass("active");
		}
	});
});
